import type { IconImage } from "../common/components/icon-image";
import type { WireModalSize } from "./parsed-path";
import type { WireAction, WireComponent, WireMessage } from "./types";

export enum WireScreenFlag {
    IsSignIn = "sign-in",
}

export interface WireScreen {
    // Right now this is just the parsed path fragment and the depth
    readonly key: string;

    readonly title: string;

    // We're using `null` in the wire types because we want them to be JSON,
    // which doesn't have `undefined`.
    readonly components: readonly (WireComponent | null)[];
    readonly specialButtons: readonly (WireComponent | null)[];

    readonly closeAction?: WireAction;

    readonly flags: readonly WireScreenFlag[];
}

export interface WireModalScreen extends WireScreen {
    readonly size: WireModalSize;
}

export interface WireTab {
    readonly title: string;
    readonly isActive: boolean;
    readonly action: WireAction;
}

export interface WireUserProfileButton {
    readonly signedInUserEmail: string;

    // If the user profile is not configured, there won't be a name or an
    // action.
    readonly userProfileAction?: WireAction;
    readonly signedInUserName?: string;
    readonly signedInUserImage?: string;
    readonly userProfileScreenIsOpen: boolean;
}

export interface WireUserProfile {
    // If `userProfileButton` is defined, then `signInAction` and
    // `signUpAction` won't be, and vice versa. It's possible that nothing is
    // defined.
    //
    // If `signInAction` is defined, the user isn't signed in, and a
    // sign-in button should show that calls this action.  If `signUpAction`
    // is defined, the user isn't signed in, and a sign-up button should show.
    //
    // If `userProfileButton` is defined, it gives the
    // signed-in user and an action to open the user profile screen.
    readonly signInAction?: WireAction;
    readonly signUpAction?: WireAction;

    readonly signOutAction?: WireAction;

    readonly userProfileButton?: WireUserProfileButton;
}

export interface WireNavigationModel extends WireUserProfile {
    readonly urlPath: string;

    readonly appTitle: string;
    readonly appTitleAction?: WireAction;

    readonly blockingMessage?: WireMessage;

    readonly tabs: readonly WireTab[];

    readonly screen: WireScreen;
    readonly modal?: WireModalScreen;

    readonly removeBranding: boolean;

    readonly iconImage?: IconImage;
}
